<template>
  <div class="px-5 py-4">
    <integration-page-header
      :title="$t('INTEGRATION_SETTINGS.DIRECT_CHAT.PAGE_TITLE')"
      :description="$t('INTEGRATION_SETTINGS.DIRECT_CHAT.PAGE_DESC')"
      :hint-description="hintDescription"
    />

    <div class="mt-2 grid grid-cols-2 gap-3">
      <chat-with-customers />
      <chat-with-business />
      <wa-widget />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import IntegrationPageHeader from '../components/IntegrationPageHeader.vue';
import ChatWithBusiness from './ChatWithBusiness.vue';
import ChatWithCustomers from './ChatWithCustomers.vue';
import WaWidget from './WaWidget.vue';

export default {
  components: {
    ChatWithBusiness,
    ChatWithCustomers,
    IntegrationPageHeader,
    WaWidget,
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      getAccount: 'accounts/getAccount',
    }),
    account() {
      return this.getAccount(this.accountId);
    },
    iPracticomFeatures() {
      return this.account.platform_features?.iPracticom;
    },
    oneCityFeatures() {
      return this.account.platform_features?.one_city;
    },
    hintDescription() {
      const text = this.$t('INTEGRATION_SETTINGS.DIRECT_CHAT.HINT.DESC');
      const platformLink = 'https://chat.99digital.co.il';
      if (this.iPracticomFeatures) {
        return text.replace(platformLink, 'https://chat.ip-com.co.il');
      }
      if (this.oneCityFeatures) {
        return text.replace(platformLink, 'https://www.onecity.co.il');
      }
      return text;
    },
  },
};
</script>
